import React from 'react';

const RelayDialog = ({ isOpen, relayOn, hours, onHoursChange, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
        <div style={{ background: '#ffffff', padding: '24px', borderRadius: '8px', width: '90%', maxWidth: '300px', textAlign: 'center' }}>
            <p style={{ marginBottom: '16px', fontSize: '16px', color: '#000' }}>
                {relayOn ? 'Relay is ON. Switch it off?' : 'Switch the relay on for how many hours?'}
            </p>

            {!relayOn && (
                <select
                    value={hours}
                    onChange={(e) => onHoursChange(Number(e.target.value))}
                    style={{ width: '100%', marginBottom: '16px', padding: '10px', fontSize: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', color: '#000', background: '#ffffff' }}
                >
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                        <option key={h} value={h}>{h} {h === 1 ? 'hour' : 'hours'}</option>
                    ))}
                </select>
            )}

            <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={onConfirm} style={{ flex: 1, padding: '12px', background: '#AE3041', color: '#ffffff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {relayOn ? 'Switch Off' : 'Switch On'}
                </button>
                <button onClick={onCancel} style={{ flex: 1, padding: '12px', background: '#f5f5f5', color: '#000', border: '1px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
            </div>
        </div>
    </div>
  );
};

export default RelayDialog;
